module.exports = __webpack_public_path__ + "finance.e163e319d1243026bfdc.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/finance/webfont/finance.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/finance/webfont/finance.ttf
// module chunks = styles